import React from 'react';
import './addon-shop.css';
import { useTranslation } from 'react-i18next';
import { planLimits } from '../../utils/planHelpers';

export default function UpgradeCard({ selected, onSelect, currentPlan }) {
  const { t } = useTranslation('addons');

  // No mostrar a usuarios Pro
  if (currentPlan === 'pro') return null;

  const handleClick = () => {
    onSelect('upgrade_pro');
  };

  return (
    <div
      className={`addon-card upgrade-card ${selected ? 'selected' : ''}`}
      onClick={handleClick}
    >
      <span className="badge badge-recommended">{t('badges.recommended')}</span>

      <div className="card-image gradient-premium">
        <span className="icon-large">👑</span>
      </div>

      <h3 className="card-title">{t('upgrade.title')}</h3>
      <div className="card-price">
        {/* Del catálogo, no a mano: el $297 escrito aquí sobrevivió al barrido del 8-oct
            porque esta tarjeta no está en /contratar ni en la grilla. 9-oct-2026. */}
        ${planLimits.pro.price}
        <span className="price-period">{t('card.perMonth')}</span>
      </div>

      <p className="card-description">
        {t('upgrade.description')}
      </p>

      <ul className="card-benefits">
        {t('upgrade.benefits', { returnObjects: true }).map((benefit, i) => (
          <li key={i}>✓ {benefit}</li>
        ))}
      </ul>

      <label className="radio-label" onClick={(e) => e.stopPropagation()}>
        <input
          type="radio"
          name="addon-selection"
          checked={selected}
          onChange={() => onSelect('upgrade_pro')}
        />
        <span className="radio-text">{t('upgrade.cta')}</span>
      </label>
    </div>
  );
}
